var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import AutoComplete from '@/shared/components/input/select/AutoComplete';
var CompanySelector = function (_a) {
    var companies = _a.companies, selectedCompanyId = _a.selectedCompanyId, onCompanyChange = _a.onCompanyChange;
    var companyItems = useMemo(function () { return companies.map(function (c) { return ({ key: c.id, label: c.name }); }); }, [companies]);
    var selectedItem = useMemo(function () { return companyItems.find(function (c) { return c.key === selectedCompanyId; }) || null; }, [companyItems, selectedCompanyId]);
    if (companies.length > 5) {
        return (_jsx("div", __assign({ className: "margin10B" }, { children: _jsx("div", __assign({ className: "row" }, { children: _jsx("div", __assign({ className: "col-md-3" }, { children: _jsx(AutoComplete, { id: "generalSettingsCompany", items: companyItems, value: selectedItem, onChange: function (item) {
                            if (!item)
                                return;
                            var company = companies.find(function (c) { return c.id === item.key; });
                            if (company)
                                onCompanyChange(company);
                        }, mode: "edit", canClear: false }) })) })) })));
    }
    return (_jsx("ul", __assign({ className: "nav nav-tabs nav-tabs-heading", role: "tablist" }, { children: companies.map(function (company) { return (_jsx("li", __assign({ role: "presentation", className: "tab".concat(selectedCompanyId === company.id ? ' active' : ''), onClick: function () { return onCompanyChange(company); } }, { children: _jsx("span", { children: company.name }) }), company.id)); }) })));
};
export default CompanySelector;
